module.exports = __webpack_public_path__ + "static/blabber blaster sounds-afcce444d037653b8a65e521131b229d.wav";